import opendota from "./index";

export const fetchHeroes = async () => {
  const response = await opendota.get("constants/heroes");
  return response.data;
};

export const fetchHNrmlAblts = async () => {
  const response = await opendota.get(`constants/hero_abilities`);
  return response.data;
};

export const fetchHSpclAblts = async () => {
  const response = await opendota.get(`constants/aghs_desc`);
  return response.data;
};

export const fetchAllHeroAblts = async () => {
  const response = await opendota.get(`constants/abilities`);
  return response.data;
};

export const fetchItems = async () => {
  const response = await opendota.get("constants/items");
  return response.data;
};

export const fetchTeams = async () => {
  const response = await opendota.get(`teams`);
  return response.data;
};

export const fetchProPlayers = async () => {
  const response = await opendota.get(`proPlayers`);
  return response.data;
};

export const fetchHeroesPlayed = async (account_id) => {
  const response = await opendota.get(`players/${account_id}/heroes`);
  return response.data;
};

export const fetchTotals = async (account_id) => {
  const response = await opendota.get(`players/${account_id}/totals`);
  return response.data;
};

export const fetchPeers = async (account_id) => {
  const response = await opendota.get(`players/${account_id}/peers`);
  return response.data;
};

export const fetchMatches = async (account_id) => {
  const response = await opendota.get(
    `players/${account_id}/matches?limit=100`
  );
  return response.data;
};

export const fetchRankedMatchesByDate = async (account_id, queryParams) => {
  const response = await opendota.get(
    `players/${account_id}/Matches?${queryParams}`
  );

  return response.data;
};
